<template>
  <div>
    <!-- <div class="hero simple" style="background-image: url('/static/asx/about/Honeyview_company_intro.jpg')">
      <div class="content">
        <h1 class="hero-title">{{ itemTitle }}</h1>
      </div>
    </div> -->
    <div class="menu_bg"></div>
    <div class="product-container">
      <div class="content">
        <h1 class="hero-title">{{ $t('messages.aboutUs') }}</h1>
      </div>
    </div>
    <div class="sections-container">
      <div style="width: 420px;max-height: 480px;">
        <section id="nav_menu-2" class="widget widget_nav_menu">
          <h2 class="widget-title">{{ $t('messages.aboutUs') }}</h2>
          <div class="menu-about-menu-container">
            <ul id="menu-about-menu" class="menu">
              <li v-for="(item, index) in menuItems" :key="item.id" :class="{ active: activeIndex === index }">
                <div class="a_container">
                  <a @click="handleClick(index)">
                    {{ $t(`messages.${item.title}`) }}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="right-container">
        <!-- 公司简介 -->
        <div v-if="activeIndex == 0" class="section-content">
          <el-image
            src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/company_intro.jpg"
            fit="contain">
            <!-- <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div> -->
          </el-image>
          <div style="color: #6f6f6f;font-size: 20px;margin-top: 10px;">
            {{ $t('messages.aboutCompanyIntro') }}
          </div>
        </div>
        <!-- 团队介绍 -->
        <div v-if="activeIndex == 1" class="section-content">
          <el-image style="width: 20vw;"
            src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/董事长---张刚.jpg"
            fit="contain"></el-image>
          <div
            style="color: #6f6f6f;font-size: 16px;margin-top: 10px; margin-bottom: 15px;border-bottom: 3px dashed rgba(40, 80, 124, .15);padding-bottom: 20px;">
            {{ $t('messages.aboutGroupBoss') }}
          </div>
          <el-image style="width: 20vw;"
            src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/运营负责人---陈勇.jpg"
            fit="contain"></el-image>
          <div
            style="color: #6f6f6f;font-size: 16px;margin-top: 10px; margin-bottom: 15px;border-bottom: 3px dashed rgba(40, 80, 124, .15);padding-bottom: 20px;">
            {{ $t('messages.aboutGroupCEO') }}
          </div>
          <el-image style="width: 20vw;"
            src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/技术负责人---秦锋.jpg"
            fit="contain"></el-image>
          <div style="color: #6f6f6f;font-size: 16px;margin-top: 10px; margin-bottom: 15px;">
            {{ $t('messages.aboutGroupCTO') }}
          </div>
        </div>
        <!-- 公司能力 -->
        <div v-if="activeIndex == 2" style="display: flex;flex-direction: column;">
          <el-carousel :interval="5000" arrow="always" height="500px" style="min-width: 400px;width: 800px;">
            <el-carousel-item v-for="(item, index) in companyImageList" :key="index">
              <el-image :src="item" fit="contain">
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <div v-if="activeIndex == 3" class="section-content">
          <el-image style="width: 60vw;"
            src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/Honeyview_合作伙伴.png"
            fit="contain"></el-image>
        </div>
        <!-- 认证资质 -->
        <div v-if="activeIndex == 4" class="section-content">
          <el-carousel :interval="5000" arrow="always" height="700px" style="width: 600px;">
            <el-carousel-item v-for="(item, index) in certificationImageList" :key="index">
              <el-image :src="item" fit="contain">
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  // components: {
  //   CategoryMenu
  // }
  data () {
    return {
      activeIndex: 0,
      menuItems: [
        { id: 1001, title: 'companyProfile' },
        { id: 1002, title: 'management' },
        { id: 1004, title: 'about' },
        { id: 1003, title: 'partners' },
        { id: 1005, title: 'certification' },
      ],
      companyImageList: [
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/CNC车床.jpg",
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/CNC车床2.jpg",
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/电镀.jpg",
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/二次加工车间.jpg",
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/实验室.jpg",
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/组装车间.jpg"
      ],
      certificationImageList: [
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/东莞安晟讯-QE-S2-IAS证书(1)_00.jpg",
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/东莞安晟讯-QE-S2-IAS证书(1)_01.jpg",
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/东莞安晟讯-QE-S2-IAS证书(1)_02.jpg",
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/东莞安晟讯-QE-S2-IAS证书(1)_03.jpg",
        "https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/about/东莞安晟讯-QE-S2-IAS证书(1)_04.jpg"
      ]
    };
  },

  mounted () {
    console.log('this.$route.params.index', this.$route.params)
    this.activeIndex = this.$route.params.index ? this.$route.params.index : 0;
  },
  computed: {
    itemTitle () {
      console.log("activeIndexxxx: ", this.activeIndex)
      return this.$t(`messages.${this.menuItems[this.activeIndex].title}`)
    }
  },
  methods: {
    handleClick (index) {
      this.activeIndex = index;
      console.log('handleClick', index)
    },
  }
};
</script>

<style scoped>
.hero.simple {
  height: 475px;
  width: 100%;
  position: relative;
  background-size: cover;
}

.hero.simple:after {
  z-index: 1;
  content: "";
  background: rgba(0, 0, 0, 0) linear-gradient(180deg, #000000 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.5;
}

@media (max-width: 1539px) {
  .hero.simple .content {
    padding: 24px 0 18px 48px;
  }
}

.hero.simple .content {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-008682) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.hero.simple .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}

.menu_bg {
  height: 100px;
  width: 100%;
  position: relative;
  background-size: cover;
  background-color: #00579C;
}



.product-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.content {
  /* position: absolute; */
  /* bottom: 0; */
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-008682) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.content .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}


@media (max-width: 1539px) {
  .sections-container {
    -webkit-padding-start: 49px;
    padding-inline-start: 49px;
    -webkit-padding-end: 49px;
    padding-inline-end: 49px;
    gap: 70px;
  }
}

@media (max-width: 1919px) {
  .sections-container {
    gap: 80px;
  }
}

@media (min-width: 1920px) {
  .sections-container {
    gap: 90px;
    padding-inline-start: 80px;
    padding-inline-end: 80px;
  }
}

.sections-container {
  display: flex;
  /* justify-content: space-between; */
  flex-direction: row;
  margin-top: 54px;
  -webkit-padding-start: 70px;
  padding-inline-start: 70px;
  -webkit-padding-end: 70px;
  padding-inline-end: 70px;
}

.section-content {
  /* margin-left: 80px; */
  max-width: 50vw;
  display: flex;
  flex-direction: column;
  align-items: center;

}


.widget_nav_menu {
  padding: 24px 0;
}

.widget {
  margin: 0 0 1.5em;
}

.widget_nav_menu {
  width: 100%;
  height: 100%;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, .1607843137);
  border-radius: 10px;
  background-color: #fafafa;
  padding-top: 24px;
}

.widget_nav_menu h2 {
  margin: 0;
  font-size: 37px;
  line-height: 56px;
  color: #0077b4;
  -webkit-padding-start: 40px;
  padding-inline-start: 40px;
}

.widget_nav_menu .menu-about-menu-container ul {
  list-style: none;
  margin: 10px 0 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.widget_nav_menu .menu-about-menu-container ul li {
  height: 54px;
  padding-top: 12px;
}

.widget_nav_menu .menu-about-menu-container ul li:hover {
  background-color: #ddd;
}

.widget_nav_menu .menu-about-menu-container ul li.active {
  background-color: #ccc;
}

.widget_nav_menu .menu-about-menu-container ul li a {
  text-decoration: none;
  font-size: 17px;
  color: #6f6f6f;
  -webkit-padding-start: 40px;
  padding-inline-start: 40px;
  transition: linear-gradient .2s ease-in-out;
}

/* 新增的样式 */
.a_container {
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.menu a {
  text-decoration: none;
  cursor: pointer;
  background-color: transparent;
  color: black;
  padding: 5px 10px;
}

.menu a:hover {
  background-color: #ddd;
}

.menu a.active {
  background-color: #ccc;
}

.right-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  flex-grow: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/firstLevel/About.vue